module.exports = __webpack_public_path__ + "img/nft-01.6ad43b38.jpg";